/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable no-use-before-define */
import resultsReviewDispatcher from '../../action';
import {
  HS_RESULTS_REVIEW_DISPLAY_STATUS,
  HS_RESULTS_REVIEW_STATUS_COLORS,
} from '../../constants';
import ProfileScreen from './ProfileScreen';
import ReviewScreen from './ReviewScreen';
import { ArrowDown, ConfirmIcon } from '@/assets/svg';
import { ROLE_TYPES } from '@/constants/roles';
import { urlLabel } from '@/enum/PermissionEnum';
import allScreeningsDispatcher from '@/module/all-screenings/action';
import backroomModuleDispatcher from '@/module/backroom-module/action';
import {
  getResultFile,
  hasResultFile,
  isSameResultFile,
} from '@/module/backroom-module/resultFile';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import customToast from '@/new-components/CustomNotification';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import { CustomStatusComponent } from '@/new-components/CustomStatusComponent';
import {
  Box,
  Button,
  CircularProgress,
  withStyles,
  ButtonGroup,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

const CustomButtonGroup = withStyles((theme) => ({
  root: {
    gap: 8,
    display: 'flex',
    flexDirection: 'row',
    padding: 4,
    borderRadius: 8,
    backgroundColor: theme.palette.grey.disableBackground,

    '& .MuiButtonGroup-groupedHorizontal:not(:last-child)': {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
      padding: 0,
      width: '150px',
    },
    '& .MuiButtonGroup-groupedHorizontal:not(:first-child)': {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      padding: 0,
      width: '150px',
    },
  },
}))(ButtonGroup);

const useStyles = makeStyles((theme) => ({
  reviewButton: {
    backgroundColor: '#F1F1F1',
    color: '#000',
    '&.Mui-selected, &:active, &:focus': {
      backgroundColor: '#AD5E99',
      color: '#fff',
    },
  },
  reviewButtonActive: {
    backgroundColor: '#AD5E99 !important',
    color: '#fff !important',
  },
  reviewButtonDisabled: {
    backgroundColor: '#F1F1F1 !important',
    color: '#A0A0A0 !important',
  },
}));

const ResultsReviewDetail = () => {
  const query = new URLSearchParams(useLocation().search);
  const paxScreeningId = query.get('paxScreeningId');
  const reviewId = query.get('reviewId');
  const backroomStatus = query.get('backroomStatus');

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0); // 0: Profile, 1: Review
  const [dataInfo, setDataInfo] = useState(null);
  const [reviewData, setReviewData] = useState(null);
  const [holdDataBackroom, setHoldDataBackroom] = useState(null);
  const [downloadLinksMap, setDownloadLinksMap] = useState({});

  const [showSubmitAll, setShowSubmitAll] = useState(false);
  const [isSubmitAll, setIsSubmitAll] = useState(false);

  const [formValues, setFormValues] = useState({});
  const classes = useStyles();

  const userInfo = useSelector((state) => state.auth.userInfo);
  const isRemindSave = useSelector(
    (state) => state.resultsReviewBackroom.isRemindSave
  );
  const isAdmin =
    userInfo.roleName === ROLE_TYPES.SUPER_ADMIN ||
    userInfo.roleName === ROLE_TYPES.SYSTEM_ADMIN;

  useEffect(() => {
    if (paxScreeningId) {
      setLoading(true);
      allScreeningsDispatcher.getData(paxScreeningId, (result) => {
        setDataInfo(result);
        setLoading(false);
      });

      // fetchData();

      resultsReviewDispatcher.getReviewById(reviewId, (result) => {
        // setReviewData(result);
        backroomModuleDispatcher.getBackroomDetails(
          paxScreeningId,
          async (data) => {
            // Create promises for all download link requests

            const filterData = data.filter(hasResultFile);
            const downloadLinkPromises = filterData.map((item) => {
              return new Promise((resolve) => {
                resultsReviewDispatcher.getLinkDownloadBackroom(
                  paxScreeningId,
                  item.moduleId,
                  (link) => {
                    resolve({ moduleId: item.moduleId, link });
                  }
                );
              });
            });

            // Wait for all promises to resolve
            const downloadLinksResults = await Promise.all(
              downloadLinkPromises
            );

            // Build the download links map
            const downloadLinksMap = {};
            downloadLinksResults.forEach(({ moduleId, link }) => {
              downloadLinksMap[moduleId] = link;
            });
            // Store downloadLinksMap in state
            setDownloadLinksMap(downloadLinksMap);
            // Map result data with download links
            const mappedResult = {
              ...result,
              testReviewItems: result.testReviewItems?.map((testItem) => {
                // Match the module to the review item by stored file. The API
                // now returns a full S3 URL where the review item still carries
                // a path, so the two are compared as object keys.
                const matchingModule = data.find((module) =>
                  isSameResultFile(
                    getResultFile(module),
                    testItem.documentFilePath
                  )
                );

                if (
                  matchingModule &&
                  downloadLinksMap[matchingModule.moduleId]
                ) {
                  return {
                    ...testItem,
                    moduleId: matchingModule.moduleId,
                    link: downloadLinksMap[matchingModule.moduleId], // Add new link field
                  };
                }

                return testItem;
              }),
            };
            setHoldDataBackroom(mappedResult?.testReviewItems);
            setReviewData(mappedResult);
          }
        );
      });
    }
  }, [paxScreeningId, reviewId]);

  const fetchData = async () => {
    if (paxScreeningId && reviewId) {
      resultsReviewDispatcher.getReviewById(reviewId, (result) => {
        // Map result data with download links using stored downloadLinksMap
        const mappedResult = {
          ...result,
          testReviewItems: result.testReviewItems?.map((testItem) => {
            // Match by stored file, not by raw string: a refetch can spell the
            // same file differently (full S3 URL vs path, percent-escapes),
            // which would drop the already-resolved download link.
            const matchingModule = holdDataBackroom?.find((module) =>
              isSameResultFile(
                module.documentFilePath,
                testItem.documentFilePath
              )
            );

            if (matchingModule && downloadLinksMap[matchingModule.moduleId]) {
              return {
                ...testItem,
                moduleId: matchingModule.moduleId,
                link: downloadLinksMap[matchingModule.moduleId], // Add new link field
              };
            }

            return testItem;
          }),
        };
        setReviewData(mappedResult);
      });
    }
  };
  // Back arrow handler
  const handleBack = () => {
    history.goBack();
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  const handleSaveDraft = (value) => {
    resultsReviewDispatcher.updateIndividualTestReview(
      reviewId,
      value.id,
      {
        reviewStatus: value.reviewStatus,
        screeningResult: value.evaluation,
        comment: value.comment,
      },
      () => {
        customToast(
          'success',
          'Your review is saved.',
          'FUT Documents updated'
        );
        fetchData();
      }
    );
  };

  const handleSubmitReview = () => {
    resultsReviewDispatcher.submitIndividualTestReview(
      reviewId,
      formValues.id,
      {
        reviewStatus: formValues.reviewStatus,
        screeningResult: formValues.evaluation,
        comment: formValues.comment,
      },
      () => {
        customToast(
          'success',
          <>
            FUT documents for <strong>{dataInfo.paxInfo.fullName}</strong> has
            been completedly reviewed.
          </>,
          'FUT transaction updated'
        );
        fetchData();
        setShowSubmitAll(false);
        setIsSubmitAll(false);
      }
    );
  };

  const handleSubmitAll = async (value) => {
    let params = isEmpty(formValues) ? value : formValues;

    resultsReviewDispatcher.submitAllReview(params, reviewId, async () => {
      if (params.submitAll) {
        customToast(
          'success',
          <>
            FUT documents for <strong>{dataInfo.paxInfo.fullName}</strong> has
            been completedly reviewed.
          </>,
          'FUT transaction updated'
        );
        fetchData();
        history.push(`/${urlLabel.resultsReviewModule}`);
        setShowSubmitAll(false);
        setIsSubmitAll(false);
      } else {
        customToast(
          'success',
          'Your review is saved.',
          'FUT Documents updated'
        );
        fetchData();
      }
    });
  };

  const testReviewItems = Array.isArray(reviewData?.testReviewItems)
    ? reviewData.testReviewItems
    : [];
  const hasAnyReviewDocument = testReviewItems.some(
    (item) => item.documentFilePath
  );
  const isAllOptOutTests =
    testReviewItems.length > 0 &&
    testReviewItems.every((item) => Boolean(item?.isOptOut));
  const isReviewTabDisabled = !hasAnyReviewDocument || isAllOptOutTests;

  return (
    <>
      <CustomPaperContainer
        header={
          <CustomHeader
            isSearch={false}
            title={
              <Box display="flex" alignItems="center" gridGap={8}>
                <Box
                  component="span"
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: 8,
                  }}
                  onClick={() => {
                    if (isRemindSave) {
                      customToast(
                        'error',
                        'Please remember to save your changes, otherwise your input will not be saved.'
                      );
                    } else {
                      handleBack();
                    }
                  }}
                >
                  <ArrowDown
                    style={{
                      transform: 'rotate(90deg)',
                      fontSize: 28,
                      color: '#666',
                    }}
                  />
                </Box>
                {dataInfo.paxInfo.fullName}
                <CustomStatusComponent
                  filterList={HS_RESULTS_REVIEW_DISPLAY_STATUS}
                  filterListColor={HS_RESULTS_REVIEW_STATUS_COLORS}
                  status={reviewData?.overallReviewStatus}
                />
              </Box>
            }
            renderButton={() => (
              <CustomButtonGroup>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: tab === 0 ? '#AD5E99' : '#F1F1F1',
                  }}
                  color={tab === 0 ? 'primary' : 'default'}
                  onClick={() => {
                    setTab(0);
                  }}
                >
                  Profile
                </Button>
                <Button
                  variant="contained"
                  className={
                    `${classes.reviewButton} ` +
                    (isReviewTabDisabled
                      ? classes.reviewButtonDisabled
                      : tab === 1
                      ? classes.reviewButtonActive
                      : '')
                  }
                  color={tab === 1 ? 'primary' : 'default'}
                  onClick={() => {
                    setTab(1);
                  }}
                  disabled={isReviewTabDisabled}
                >
                  Review
                </Button>
              </CustomButtonGroup>
            )}
          />
        }
      >
        {tab === 0 ? (
          <ProfileScreen dataInfo={dataInfo} />
        ) : (
          <ReviewScreen
            paxScreeningId={paxScreeningId}
            reviewData={reviewData}
            backroomStatus={backroomStatus}
            setIsSubmitAll={setIsSubmitAll}
            onSaveDraft={handleSaveDraft}
            isAdmin={isAdmin}
            onSubmitAll={(value) => {
              if (value.submitAll) {
                setShowSubmitAll(true);
                setFormValues(value);
              } else {
                handleSubmitAll(value);
              }
            }}
            onSubmitReview={(value) => {
              setFormValues(value);
              setShowSubmitAll(true);
            }}
          />
        )}
      </CustomPaperContainer>

      {showSubmitAll && (
        <ModalConfirmation
          open={showSubmitAll}
          onClick={() => {
            if (isSubmitAll) {
              handleSubmitAll();
            } else {
              handleSubmitReview();
            }
          }}
          onClose={() => setShowSubmitAll(false)}
          mainContent={'Submit Review Confirmation'}
          subContent={
            'Are you sure you want to submit the review? This action cannot be undone.'
          }
          cancelLabel="Cancel"
          confirmLabel="Confirm"
          Icon={<ConfirmIcon />}
          style={{
            padding: '40px 20px 20px',
          }}
        />
      )}
    </>
  );
};

export default ResultsReviewDetail;
